module.exports = __webpack_public_path__ + "static/redux.f73de4f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/redux.png
// module id = ./src/images/redux.png
// module chunks = 4910047194780788000